export default "__VITE_ASSET__12cd41a5__"